module.exports = __webpack_public_path__ + "static/media/capitalMarkets.65327fbe.png";